const PlannerHeader = () => {
  return (
    <div className="inline-flex gap-6 items-center">
      <h1 className="text-black-light text-3xl leading-10 font-normal">Planner</h1>
    </div>
  );
};

export default PlannerHeader;
